import axiosInstance from "../api/axiosConfig";

export const sendOtp = async (msisdn, context) => {
  try {
    const response = await axiosInstance.post(`/auth/otp/send`, {
      channel: "sms",
      targetIdentifier: msisdn,
      context: context,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const validateOtp = async (otp, msisdn) => {
  try {
    const response = await axiosInstance.post(`/auth/otp/validate`, {
      otp: otp,
      targetIdentifier: msisdn,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const registerCustomer = async (formData) => {
  try {
    const response = await axiosInstance.post("/auth/register", formData);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const registerCustomerWithAgent = async (formData) => {
  try {
    const response = await axiosInstance.post("/auth/register?bp_proxy=true", formData);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const statusCheck = async (premiseRef) => {
  try {
    const response = await axiosInstance.get(
      `/locations/coverage/addressstatus/?premiseRefISP=${premiseRef}`
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const placeOrder = async (orderType, formData, bpProxy = false) => {
  try {
    const response = await axiosInstance.post(`/orders/${orderType}?bp_proxy=${bpProxy}`, formData);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const placeOrderWithAgent = async (orderType, formData) => {
  try {
    const response = await axiosInstance.post(`/orders/${orderType}?bp_proxy=true`, formData);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const orderResubmit = async (orderType, data) => {
  try {
    const response = await axiosInstance.post(`/orders/${orderType}`, data);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const createLocation = async (location) => {
  try {
    const response = await axiosInstance.post(`/locations`, location);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getCustomerFromMsisdn  = async (msisdn) => {
  try {
    const response = await axiosInstance.get(`/auth/customers?msisdn=${msisdn}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getDBLocationDetails = async (premiseRefISP) => {
  try {
    const response = await axiosInstance.get(`/locations?premiseRefISP=${premiseRefISP}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};
